import AllCustomerCommentList from "../../components/customer/AllCustomerCommentList";

const AllCustomerCommentsPage = () => {

    return <AllCustomerCommentList/>
}

export default AllCustomerCommentsPage;
